import {
	Button,
	HStack,
	VStack,
	Text,
	H1,
} from '@montel/montelpro-shared-components-v2';
import { FunctionComponent } from 'react';
import { StandardModal } from '../../../../components/common/Modal/StandardModal';
import { Company } from 'domain/company/Company';
import SectionDivider from 'components/common/SectionDivider';

interface UnsavedChangesModalProps {
	isOpen: boolean;
	isLoading?: boolean;
	addedCompanies: Company[];
	removedCompanies: Company[];
	providerName: string;
	onDiscard: () => void;
	onKeepEditing: () => void;
	onSave: () => void;
}

export const UnsavedChangesModal: FunctionComponent<
	UnsavedChangesModalProps
> = ({
	isOpen,
	isLoading = false,
	addedCompanies,
	removedCompanies,
	providerName,
	onDiscard,
	onKeepEditing,
	onSave,
}) => (
	<StandardModal
		isOpen={isOpen}
		onClose={onKeepEditing}
		footer={
			<HStack fullWidth justify="flex-end" gap="lg">
				<Button
					text="Keep editing"
					variant="secondary"
					onClick={onKeepEditing}
				/>
				<Button
					text="Discard changes"
					variant="negative"
					onClick={onDiscard}
				/>
				<Button
					text="Save changes"
					variant="primary"
					onClick={onSave}
					isLoading={isLoading}
					loadingText="Saving..."
				/>
			</HStack>
		}
	>
		<VStack gap="md">
			<H1 size="lg">You have unsaved changes</H1>
			{addedCompanies.length > 0 && (
				<Text fontStyle="italic">
					These companies were added to the <b>{providerName}</b>{' '}
					blacklist:{' '}
					<Text fontStyle="normal">
						<b>
							{addedCompanies
								.map((company) => company.name)
								.join(', ') || 'None'}
						</b>
					</Text>
				</Text>
			)}
			{removedCompanies.length > 0 && (
				<Text fontStyle="italic">
					These companies were removed from the <b>{providerName}</b>{' '}
					blacklist:{' '}
					<Text fontStyle="normal">
						<b>
							{removedCompanies
								.map((company) => company.name)
								.join(', ') || 'None'}
						</b>
					</Text>
				</Text>
			)}
			<Text>How would you like to proceed?</Text>
		</VStack>
	</StandardModal>
);
